import { useShareToolContext } from '../../context/ShareToolContext';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const ShareToolCloseButton = () => {
  const {
    closeModal
  } = useShareToolContext();
  return /*#__PURE__*/_jsx(Button, {
    use: "tertiary-light",
    "data-test-id": "share-tool-close-button",
    onClick: closeModal,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "CommerceToolsUiLib.shareToolModal.close"
    })
  });
};